import React from "react";
import { useTranslation } from "react-i18next";
import { SPACING } from "../../../../_globalStore/redux/reducers/Theme/themeConstants";
import useAuthorization from "../../../../custom-hooks/useAuthorization/useAuthorization";
import useWindowSize from "../../../../custom-hooks/useWindowSize/useWindowSize";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";
import PendingHEApprovals from "../../../MyTeamPresenceAndLeaves/TnAOverviews/PendingEHApprovalModal/PendingHEApprovals";
import HeaderPortal from "../../../TableHeader/HeaderPortal";

const ProjectAssignmentsPendingExtraHours = () => {
  const { t } = useTranslation();
  const tRP = "components.project_assignment_pending_approvals";
  const translationFields = `${tRP}.columns`;

  const hasAccess = useAuthorization([AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves]);

  const { height } = useWindowSize();

  const currHeight =
    height -
    (SPACING[9] * 2 +
      (document.getElementById("header")?.clientHeight ?? 0) +
      SPACING[7] +
      (document.getElementById("MultitabsHorizontal-Portal")?.clientHeight ?? 0) +
      SPACING[7] +
      100);

  return (
    <>
      {hasAccess && (
        <>
          <HeaderPortal title={`${t(`${tRP}.table_title`)}`} />

          <PendingHEApprovals
            showEe
            height={currHeight}
          />
        </>
      )}
    </>
  );
};

export default ProjectAssignmentsPendingExtraHours;
